import React from 'react';
import FormSection from '@reverbdotcom/commons/src/components/form_section';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import { RCAlertBox, RCTextWithIcon } from '@reverbdotcom/cadence/components';
import { InfoCircleIcon } from '@reverbdotcom/cadence/icons/react';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { Paths } from '../shared/url_helpers';
import { EU_SELLER_TAX_INFO_HELP_CENTER_ARTICLE_ID } from './international_tax_profile_constants';

interface IProps {
  children: React.ReactNode;
}

export function InternationalTaxProfileMainFormSection({
  children,
}: IProps) {
  return (
    <FormSection
      title={<Translate text="discovery.internationalTaxProfile.taxProfileTitle" />}
      description={
        <>
          <Translate text="discovery.internationalTaxProfile.taxProfileDescription" />
          <div className="scaling-mt-2">
            <RCAlertBox
              type="info"
            >
              <RCTextWithIcon
                placement="left"
                svgComponent={InfoCircleIcon}
              >
                <CoreLink
                  className="text-link"
                  to={Paths.helpCenterArticlesUrl.expand({ articleId: EU_SELLER_TAX_INFO_HELP_CENTER_ARTICLE_ID })}
                  target="_blank"
                >
                  <Translate text="discovery.internationalTaxProfile.taxInfoHelpCenterLinkLabel" />
                </CoreLink>
              </RCTextWithIcon>
            </RCAlertBox>
          </div>
        </>}
    >
      {children}
    </FormSection>
  );
}

export default InternationalTaxProfileMainFormSection;
